import { Button } from '@mui/material';
import { useEffect, useState } from 'react';
import { Form } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal';
import { useForm } from 'react-hook-form';
import { renderMUILoadingButton } from '../../../util/util';
import { useInstrumentSettings } from '../../../util/db';
import { SETTING_TYPE } from '../TabSettings/DefineCategories';

const ModalAddStatusHistory = ({
  show,
  handleClose,
  handleSaveStatusHistory,
  data,
  instrumentStatusLogs
}) => {
  const [loading, setLoading] = useState(false);
  const [maxDateTime, setMaxDateTime] = useState('');
  const { data: instrumentSettingsInstrumentStatus = [] } = useInstrumentSettings(
    SETTING_TYPE.INSTRUMENT_STATUS
  );
  const formatDateTimeLocal = (createdAt) => {
    if (!createdAt?.seconds) return '';
    const date = new Date(createdAt.seconds * 1000);
    return formatDateTimeLocalInput(date);
  };

  const { handleSubmit, register, reset, watch } = useForm({
    defaultValues: {
      createdAt: '',
      previousStatus: '',
      currentStatus: '',
      note: ''
    }
  });

  const previousStatus = watch('previousStatus');
  const currentStatus = watch('currentStatus');

  const formatDateTimeLocalInput = (date) => {
    if (!date) return '';
    const pad = (n) => n.toString().padStart(2, '0');

    const year = date.getFullYear();
    const month = pad(date.getMonth() + 1);
    const day = pad(date.getDate());
    const hours = pad(date.getHours());
    const minutes = pad(date.getMinutes());

    return `${year}-${month}-${day}T${hours}:${minutes}`;
  };

  useEffect(() => {
    if (show) {
      const logs = instrumentStatusLogs || [];
      const latestLog = logs.reduce((latest, current) => {
        return current.createdAt?.seconds > (latest?.createdAt?.seconds || 0) ? current : latest;
      }, null);

      const latestDate = latestLog?.createdAt?.seconds
        ? new Date(latestLog.createdAt.seconds * 1000)
        : null;

      const now = new Date();
      const maxDate = latestDate && latestDate < now ? latestDate : now;

      setMaxDateTime(formatDateTimeLocalInput(maxDate));

      reset({
        id: data?.id || undefined,
        createdAt: formatDateTimeLocal(data?.createdAt),
        previousStatus: data?.prevStatus || '',
        currentStatus: data?.currentStatus || '',
        note: data?.note || ''
      });
    }
  }, [show, data, reset]);
  const onSubmit = async (data) => {
    setLoading(true);
    await handleSaveStatusHistory(data);
    setLoading(false);
  };

  const onClose = () => {
    reset();
    handleClose();
  };
  return (
    <Modal size="md" show={show} onHide={onClose} backdrop="static">
      <form onSubmit={handleSubmit(onSubmit)}>
        <Modal.Header closeButton>
          <Modal.Title>{data?.id ? 'Edit' : 'Add'} Status History</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Form.Group className="mb-3">
            <Form.Label>Date and Time</Form.Label>
            <Form.Control
              type="datetime-local"
              {...register('createdAt', { required: true })}
              max={maxDateTime}
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Previous Status</Form.Label>
            <Form.Select {...register('previousStatus', { required: true })}>
              <option value="">Select Previous Status</option>
              {instrumentSettingsInstrumentStatus
                .filter((status) => status.id !== currentStatus)
                .map((status) => (
                  <option key={status.id} value={status.id}>
                    {status.name}
                  </option>
                ))}
            </Form.Select>
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Current Status</Form.Label>
            <Form.Select {...register('currentStatus', { required: true })}>
              <option value="">Select Current Status</option>
              {instrumentSettingsInstrumentStatus
                .filter((status) => status.id !== previousStatus)
                .map((status) => (
                  <option key={status.id} value={status.id}>
                    {status.name}
                  </option>
                ))}
            </Form.Select>
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Note</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              {...register('note')}
              placeholder="Enter any notes..."
            />
          </Form.Group>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="text" onClick={onClose}>
            Cancel
          </Button>
          &nbsp; &nbsp;
          {renderMUILoadingButton({
            buttonText: 'Save',
            isLoading: loading,
            variant: 'contained',
            type: 'submit'
          })}
        </Modal.Footer>
      </form>
    </Modal>
  );
};

export default ModalAddStatusHistory;
